var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var Svg5 = function Svg5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 84,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#5_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.156 68.64 2.297-17.156C8.234 54.828 13.406 56.5 17.97 56.5c2.968 0 5.375-.75 7.218-2.25C27.063 52.75 28 50.797 28 48.39c0-2.562-1.016-4.546-3.047-5.953-2.031-1.437-4.89-2.156-8.578-2.156-4.031 0-8.266.844-12.703 2.532L9.297.624h36v17.016H24.672l-1.547 8.109a49.081 49.081 0 0 1 3.281-.14c5.938 0 10.953 2.156 15.047 6.468 4.063 4.25 6.094 9.563 6.094 15.938 0 7.5-2.625 13.75-7.875 18.75-5.188 5-11.734 7.5-19.64 7.5-6.75 0-13.376-1.875-19.876-5.625Z",
    fill: "#121213"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#5_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.672 17.64h20.625V.626h-36L3.672 42.813c.71-.27 1.417-.52 2.117-.747 3.672-1.19 7.2-1.785 10.586-1.785 3.688 0 6.547.719 8.578 2.157C26.984 43.843 28 45.828 28 48.39c0 2.406-.938 4.359-2.813 5.859-1.843 1.5-4.25 2.25-7.218 2.25-4.063 0-8.608-1.325-13.637-3.977a54.862 54.862 0 0 1-1.879-1.039L.156 68.641c6.5 3.75 13.125 5.625 19.875 5.625 7.907 0 14.453-2.5 19.64-7.5 5.25-5 7.876-11.25 7.876-18.75 0-6.375-2.031-11.688-6.094-15.938-4.094-4.312-9.11-6.469-15.047-6.469-.361 0-.77.009-1.223.026-.605.023-1.29.061-2.058.115l1.547-8.11ZM2.319 67.559c5.85 3.157 11.747 4.708 17.712 4.708 7.444 0 13.476-2.336 18.253-6.94l.008-.009c4.84-4.608 7.255-10.327 7.255-17.301 0-5.908-1.864-10.711-5.54-14.556l-.004-.005c-3.717-3.915-8.209-5.846-13.597-5.846-.778 0-1.82.044-3.142.136l-2.59.18 2.343-12.284h20.28V2.625h-32.25L6.082 39.88c3.524-1.058 6.958-1.599 10.294-1.599 3.908 0 7.23.756 9.725 2.518 2.589 1.796 3.9 4.406 3.9 7.592 0 3.01-1.21 5.536-3.557 7.416-2.28 1.852-5.166 2.693-8.474 2.693-4.3 0-8.95-1.34-13.92-3.87L2.32 67.558Z",
    fill: "#D0DF00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "5_svg__a",
    x: 0.156,
    y: 0.625,
    width: 61.391,
    height: 82.641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "5_svg__b",
    x: 0.156,
    y: 0.625,
    width: 61.391,
    height: 82.641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
};
export default Svg5;